import { Badge, Button } from '@themesberg/react-bootstrap';
import moment from 'moment';
import React from 'react'
import { deleteTicket, updateStatusTicket } from '../../../../controller/api/__classic__/ticketStorage';
import ImagePreview from '../../ticket/sub-screen/image-preview/ImagePreview';

const TableRow = (props) => {
  const { rIndex, id, channelName, createdAt, numbers, inputAmount, resultDate, status, cookies, images, onEdit, onRefresh } = props;

  const [showImagePreview, setShowImagePreview] = React.useState(false);

  const datedString = moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()

  return (
    <tr>
      <td className='text-center fw-bold'>{rIndex + 1}</td>
      <td className='text-center'>
        <Badge bg="info">Vé đơn</Badge>
      </td>
      <td style={{ fontSize: 25 }} className='text-center text-danger fw-bold'>{(numbers || "").split('').join(' ')}</td>
      <td className='text-center fw-bold'>{inputAmount}</td>
      <td className='text-center'>
        {images ? (
          <img 
            src={images && typeof images === 'string' && images.startsWith('http') ? images : `data:image/jpeg;base64,${images}`} 
            alt="Ticket" 
            style={{ maxWidth: '60px', maxHeight: '60px', cursor: 'pointer' }} 
            onClick={() => setShowImagePreview(true)}
          />
        ) : '-'}
      </td>
      <td>
        {status === 0 &&
          <Button variant='warning' onClick={async () => {
            let result = await deleteTicket(cookies.lottmekong, id)
            if (result != null) {
              onRefresh && onRefresh()
            }
          }}>
            Xóa
          </Button>
        }
        &nbsp;&nbsp;&nbsp;&nbsp;
        {(status === 0 || status === 6) &&
          <Button variant='warning' onClick={onEdit}>
            Sửa
          </Button>
        }
        &nbsp;&nbsp;&nbsp;&nbsp;
        {(status === 1) &&
            <Button variant='warning' onClick={async () => { let result = await updateStatusTicket(cookies.lottmekong,id,6) 
              if(result != null)
              {
                onRefresh && onRefresh()
              }
              }}>
              Tạm ngưng
            </Button>
        }
        &nbsp;&nbsp;&nbsp;&nbsp;
        {(status === 6) &&
            <Button variant='warning' onClick={async () => { let result = await updateStatusTicket(cookies.lottmekong,id,1) 
              if(result != null)
              {
                onRefresh && onRefresh()
              }
              }}>
              Hoạt động
            </Button>
        }
      </td>
      <ImagePreview 
        show={showImagePreview} 
        onHide={() => setShowImagePreview(false)} 
        image={images} 
        title={`Vé số ${numbers}`}
      />
    </tr>
  );
};

export default React.memo(TableRow)